import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { FormattedMessage } from 'react-intl';
import { useCallback } from 'react';

import { Button } from 'ui-components/components/button';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { messages } from '../messages';
import style from '../select-products-table.module.less';

const ActionsCell = ({ row, handleProductDeleted }) => {
  const { productId } = row?.original || {};

  const onClick = useCallback(() => {
    handleProductDeleted(productId);
  }, [handleProductDeleted, productId]);

  return (
    <Button className={style['delete-button']} onClick={onClick} theme='unstyled'>
      <FontAwesomeIcon icon={faTrash} />
    </Button>
  );
};

export const createActionsColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'actions',
  Header: <FormattedMessage {...messages.actionsColumnHeader} />,
  Cell: ActionsCell,
  width: 1,
  className: style['actions-cell'],
});
